export const card = {
  colorScheme: {
    light: {
      root: {
        background: '#ffffffff',
        color: '{surface.700}',
      },
      subtitle: {
        color: '{surface.500}',
      },
    },
    dark: {
      borderRadius: '1rem',
      root: {
        background: '#3c434f',
        color: '{surface.100}',
      },
      subtitle: {
        color: '{surface.400}',
      },
    },
  },
};
